import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './period.css';
import { dateFormateSend } from '../../../Date_Formate_Utilitiy/Index';
import Footer from '../../../home_page/Footer';
import { closeModal } from '../../../../redux/actions/action-creator';
import { validateDateInput, formatDateString, getFinancialYear, parseYear } from '../../../../utils/dateUtils';
import useClickOutside from '../../../Custom_Hooks/useClickOutsSide';

const Period = (props) => {
 
    const dispatch = useDispatch();
    const [date, setDate] = useState({ from: '', to: '', show_date: '' });
  
    const fromInputRef = useRef(null);
    const toInputRef = useRef(null);
  
   const { company_session } = useSelector(state => state.common);

  const handleFromDateChange = (inputValue) => {
    const parsedDate = validateDateInput(inputValue);
    if (!parsedDate) {
      alert('Invalid date');
      return;
    }
    const { day, month, year } = parsedDate;
    const financialYear = getFinancialYear(company_session);
    
    let targetYear = year;
    if (!year) {
      // If no year provided, determine based on month
      targetYear = month <= 3 ? financialYear.endYear : financialYear.startYear;
    } else if (year < 100) {
      // 2-digit year
      const currentYear = new Date().getFullYear();
      targetYear = parseYear(year, currentYear);
    }


    const formattedDate = formatDateString(day, month, targetYear);
    setDate(prev => ({ 
      ...prev, 
      from: formattedDate.display, 
      show_date: formattedDate.display 
    }));
    
    toInputRef.current?.focus();
  };

  const handleToDateChange = (inputValue) => {
    if (!date.show_date) {
      alert('Please enter from date first');
      return;
    }

    const parsedDate = validateDateInput(inputValue);
    if (!parsedDate) {
      alert('Invalid date format. Use DD.MM.YYYY, DD/MM/YY, DD MMM YY, or DD[MMM]YYYY');
      return;
    }

    const { day, month, year } = parsedDate;
    const fromDate = new Date(date.show_date);
    const fromMonth = fromDate.getMonth() + 1;
    const fromDay = fromDate.getDate();
    const fromYear = fromDate.getFullYear();

    let targetYear = year;
    if (!year) {
      targetYear = fromYear;
    } else if (year < 100) {
      const currentYear = new Date().getFullYear();
      const currentCentury = Math.floor(currentYear / 100) * 100;
      targetYear = year + currentCentury;
    }

    // Validate date range
    if (targetYear < fromYear || 
        (targetYear === fromYear && month < fromMonth) ||
        (targetYear === fromYear && month === fromMonth && day < fromDay)) {
      alert('To date must be after from date');
      return;
    }

    const formattedDate = formatDateString(day, month, targetYear);
    
    props?.setDate({
      ...props.date,
      show_from_date: date.show_date,
      show_to_date: formattedDate.display,
      send_from_date: dateFormateSend(date.from),
      send_to_date: formattedDate.send
    });
    
    dispatch(closeModal('period'));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setDate(prev => ({ ...prev, [name]: value }));
  };

  const handleKeyUp = (e) => {
    const { name, value } = e.target;
    
    if (e.key === 'Enter' && value.trim()) {
      e.preventDefault();
      
      if (name === 'from') {
        handleFromDateChange(value);
      } else if (name === 'to') {
        handleToDateChange(value);
      }
    }
  };

  const handleClickOutside = (event) => {
    if (fromInputRef.current) {
      event.preventDefault();
      fromInputRef.current.focus();
    }
  };
  
  const handleClickInside = (event) => {
    let clickedElement = event.target;
    if (clickedElement?.tagName && (clickedElement?.tagName.toLowerCase() === 'input' || clickedElement?.tagName.toLowerCase() === 'textarea')) {
      clickedElement.focus();
    }
  };


  useClickOutside(handleClickOutside, handleClickInside);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        dispatch(closeModal('period'));
        e.stopPropagation();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [dispatch]);

  return (
    <div className='my-card'>
      <div className='cross_button' onClick={() => dispatch(closeModal('period'))}>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x" viewBox="0 0 16 16">
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
        </svg>
      </div>
      
      <div className='container pb-3' id='card-period'>
        <div className='row'>
          <div className='col'>
            <b className='border-bottom'>Voucher Date</b>
          </div>
        </div>
        
        <div className='row'>
          <form autoComplete='off' onSubmit={(e) => e.preventDefault()}>
            <div className='col'>
              <div className='d-flex justify-content-between align-item-center'>
                <label className='lab-1'>From Date</label>
                <label>:</label>
                <input
                  type='text'
                  autoFocus
                  name='from'
                  id='from'
                  ref={fromInputRef}
                  onChange={handleChange}
                  onKeyUp={handleKeyUp}
                  value={date.from || ''}
                  className='lab-right'
                />
              </div>
              
              <div className='d-flex justify-content-between align-item-center'>
                <label className='lab-1'>To</label>
                <label>:</label>
                <input
                  type='text'
                  name='to'
                  id='to'
                  ref={toInputRef}
                  onChange={handleChange}
                  onKeyUp={handleKeyUp}
                  value={date.to || ''}
                  className='lab-right'
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      
      <div className='tomasterfooter'>
        <Footer />
      </div>
    </div>
  );
}

export default Period;
